module.exports = __webpack_public_path__ + "static/media/road.6651dd4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/road.jpg
// module id = 3565
// module chunks = 0